import { configureRequest, replacePathVariables } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import { GetOrderUspsLabelRequest, GetOrderUspsLabelSuccessResponse } from './getOrderUspsLabel.types'

export const getOrderUspsLabelApi = async (
  request: GetOrderUspsLabelRequest
): Promise<GetOrderUspsLabelSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.logisticsPartner.getOrderUspsLabel, { orderId: request.orderId }),
    method: 'GET',
    headers: {
      'X-User-Role': UserRole.logisticsPartner
    }
  })

  return response as GetOrderUspsLabelSuccessResponse
}
